import { doc, serverTimestamp, updateDoc } from "firebase/firestore";
import { db } from "../../../lib/firebase";
import type { SmartTagAttachmentFile, VCard } from "../../../types/vcard";

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value);

export const getGlovesApparelWarrantyFiles = (
  formData: Partial<VCard>,
): SmartTagAttachmentFile[] => {
  const categorySpecificInfo = formData.categorySpecificInfo;
  if (!isRecord(categorySpecificInfo)) {
    return [];
  }

  const snowGear = categorySpecificInfo.snowGear;
  if (!isRecord(snowGear)) {
    return [];
  }

  const glovesApparel = snowGear.glovesApparel;
  if (!isRecord(glovesApparel)) {
    return [];
  }

  const attachments = glovesApparel.attachments;
  if (!isRecord(attachments)) {
    return [];
  }

  const warranty = attachments.warranty;
  if (!isRecord(warranty) || !Array.isArray(warranty.files)) {
    return [];
  }

  return warranty.files as SmartTagAttachmentFile[];
};

export const withGlovesApparelWarrantyFiles = (
  formData: Partial<VCard>,
  files: SmartTagAttachmentFile[],
): Partial<VCard> => {
  const categorySpecificInfo = isRecord(formData.categorySpecificInfo)
    ? formData.categorySpecificInfo
    : {};
  const snowGear = isRecord(categorySpecificInfo.snowGear)
    ? categorySpecificInfo.snowGear
    : {};
  const glovesApparel = isRecord(snowGear.glovesApparel)
    ? snowGear.glovesApparel
    : {};
  const attachments = isRecord(glovesApparel.attachments)
    ? glovesApparel.attachments
    : {};
  const warranty = isRecord(attachments.warranty) ? attachments.warranty : {};

  return {
    ...formData,
    categorySpecificInfo: {
      ...categorySpecificInfo,
      snowGear: {
        ...snowGear,
        glovesApparel: {
          ...glovesApparel,
          attachments: {
            ...attachments,
            warranty: {
              ...warranty,
              files,
            },
          },
        },
      },
    },
  };
};

export const persistGlovesApparelWarrantyFiles = async (
  userId: string,
  files: SmartTagAttachmentFile[],
): Promise<void> => {
  const vcardRef = doc(
    db,
    `users/${userId}/vcards/active`,
    "snowGear_glovesApparel",
  );
  await updateDoc(vcardRef, {
    "categorySpecificInfo.snowGear.glovesApparel.attachments.warranty.files":
      files,
    updatedAt: serverTimestamp(),
  });
};
